export default {
  id: null,
  regulationAutoID: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/auto/sinisterhistorymodel.js